module.exports = __webpack_public_path__ + "static/Umber_Hulk-c3890d124fda2db6bf4a71005de08b1d.jpg";